import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React from 'react'

function SetupPaperAtributesDlg(
    {open, onClose, handleSave, searchString, divider,
        setAttribute
    }
) {
  return (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Setup Paper Attributes</DialogTitle>
        <DialogContent>
            <TextField
                label="Search String"
                value={searchString}
                onChange={(e) => setAttribute("searchString", e.target.value)}
                fullWidth
                margin="normal"
            />

            <TextField
                label="Divider"
                value={divider}
                onChange={(e) => setAttribute("divider", e.target.value)}
                fullWidth
                margin="normal"
            />

            </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">
                Close
            </Button>
            <Button onClick={handleSave} color="primary">
                Save
            </Button>
        </DialogActions>
    </Dialog>
  )
}

export default SetupPaperAtributesDlg